import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import ChatInterface from '../components/ChatInterface';
import MapModal from '../components/MapModal'; // KakaoMap 대신 MapModal을 임포트

import icon from '../assets/chat.svg';
import icon1 from '../assets/chatList.svg';
import icon2 from '../assets/newChat.svg';
import icon3 from '../assets/icon-park-outline_volume-notice.svg';

const CounselingPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [isMapModalOpen, setMapModalOpen] = useState(false);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(0);
  };

  return (
    <div className="counseling-page">
      <header className="counseling-header">
        <h1>
          <img src={icon} alt="리본상담" />
          리본상담
        </h1>
        <div>
          <button onClick={() => setMapModalOpen(true)} className="map-open-btn">
            주변 상담센터 찾기
          </button>
          <Link to="/counseling/list">
            <img src={icon1} alt="상담내역" />
          </Link>
          <div onClick={handleClick}>
            <img src={icon2} alt="새채팅" />
          </div>
        </div>
      </header>
      <div className="counseling-ment">
        <p>
          <img
            src={icon3}
            alt="RE:BORN TALK은 당신의 이야기를 안전하게 지켜드립니다. 말하지 못했던 마음을 편하게
          나눠보세요."
          />
          RE:BORN TALK은 당신의 이야기를 안전하게 지켜드립니다. 말하지 못했던 마음을 편하게
          나눠보세요.
        </p>
      </div>
      <ChatInterface sessionId={id} key={id} />

      <MapModal isOpen={isMapModalOpen} onClose={() => setMapModalOpen(false)} />
    </div>
  );
};

export default CounselingPage;
